import SubscriptionStateApi from '@/api/SubscriptionStateApi';
import _ from 'lodash';
import Segment from '@/Segment';

const BENEFIT_TYPES = {
  FREE_MONTHS: 'free-months',
};

const state = {
  benefitId: null,
  benefitType: null,
  benefitAmount: null,
};

const getters = {
  BENEFIT_TYPES: state => BENEFIT_TYPES,
};

const actions = {
  async initBenefits({ commit }) {
    const benefits = await SubscriptionStateApi.getBenefits();
    if (!_.isEmpty(benefits)) {
      commit('setBenefitId', benefits[0]._id);
      commit('setBenefitType', benefits[0].benefitType);
      commit('setBenefitAmount', benefits[0].benefitAmount);
    }
  },
  async redeemBenefit({ state }) {
    await SubscriptionStateApi.redeemBenefit(state.benefitId);
    Segment.trackUserGot('BenefitRedeemed', { benefitType: state.benefitType, benefitAmount: state.benefitAmount });
  },
  async createBenefit({ dispatch }, promotion) {
    await SubscriptionStateApi.createBenefit(promotion);
    await dispatch('initBenefits');
  },
};

const mutations = {
  setBenefitId(state, benefitId) {
    state.benefitId = benefitId; // eslint-disable-line
  },
  setBenefitType(state, benefitType) {
    state.benefitType = benefitType; // eslint-disable-line
  },
  setBenefitAmount(state, benefitAmount) {
    state.benefitAmount = benefitAmount; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
